
import { defineComponent, ref, watch } from 'vue';

import { Step, useStepperNavigation } from '@/components/wizard';
import CurrencyInput from '@/components/CurrencyInput.vue';
import SalaryCalculator from '@/components/SalaryCalculator.vue';
import Explain from '@/components/info/Explain.vue';
import { HealthState, useCalculationState } from '@/lib/calculationstate';

export default defineComponent({
  name: 'Salary',
  components: {
    Step,
    Explain,
    CurrencyInput,
    SalaryCalculator,
  },
  props: {
    step: { type: Number, required: true },
  },
  methods: {
    toggleCalculator() {
      this.useCalculator = !this.useCalculator;
    },
  },
  computed: {
    title() {
      if (this.state.situation === HealthState.Healthy) {
        return 'Wat is uw loon?';
      }

      return 'Wat was uw loon op uw eerste ziektedag?';
    },
  },
  setup() {
    const { currentStep } = useStepperNavigation();
    const state = useCalculationState();
    const useCalculator = ref(false);

    // Disable calculator after moving away from this page
    watch(currentStep, () => {
      useCalculator.value = false;
    });

    return {
      state,
      useCalculator,
    };
  },
});
